function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "information-circle--information-frame-info-more-help-point-circle"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.5 27.964a13.464 13.464 0 1 0 0 -26.929 13.464 13.464 0 0 0 0 26.929Z",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M11.393 20.714h6.214",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.5 20.714V13.464H12.429",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "Group 2605"
}, /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 1111",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.5 8.804a0.518 0.518 0 0 1 0 -1.036",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Ellipse 1112",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M14.5 8.804a0.518 0.518 0 0 0 0 -1.036",
  strokeWidth: 1
})));

function SvgInformationCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "-0.5 -0.5 30 30",
    height: 30,
    width: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/information-circle.bdf42e2d.svg";
export { ForwardRef as ReactComponent };